import {
  useDeleteMutation,
  useGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import {
  AUDIT_SCHEDULE,
  FIRE_SAFETY_APPLICATION,
  FIRE_SAFETY_COMMENT,
} from "tagTypes";

export const useGetDeveloperBuildingsQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/developer-building",
    query,
    tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
  });

export const useGetDefaultSchedulerQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/schedule",
    query,
    tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
  });

export const usePostRescheduleMutation = () => {
  const [addSchedule, data] = usePostMutation();
  const addAuditInformation = async (payload = {}) =>
    await addSchedule({
      endpoint: "/schedule",
      payload,
      toastMessage: "Schedular dates added successfully.",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [addAuditInformation, data];
};

export const usePutAuditConfirmationMutation = () => {
  const [auditConfirmation, data] = usePutMutation();
  const addAuditConfirmation = async (buildingInformationId, payload = {}) =>
    await auditConfirmation({
      endpoint: `/schedule/${buildingInformationId}`,
      toastMessage: "Schedular dates accepted successfully.",
      payload,
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [addAuditConfirmation, data];
};

export const usePostRescheduleAuditDatesMutation = () => {
  const [addSchedularDates, data] = usePostMutation();
  const PostSchedularDates = async (payload = {}) =>
    await addSchedularDates({
      endpoint: "/re-schedule",
      payload,
      toastMessage: "Reschedule dates added successfully",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [PostSchedularDates, data];
};

export const usePutUpdateFireSafetyApplicationStatusMutation = () => {
  const [updateStatus, data] = usePutMutation();
  const updateApplicationStatus = async (payload = {}) =>
    await updateStatus({
      endpoint: "/building-information/approve",
      payload,
      toastMessage: "Application request updated successfully",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION, FIRE_SAFETY_COMMENT],
    }).unwrap();
  return [updateApplicationStatus, data];
};
export const usePostFireSafetyApplicationBuildingAssignMutation = () => {
  const [updateStatus, data] = usePostMutation();
  const updateApplicationStatus = async (payload = {}) =>
    await updateStatus({
      endpoint: "/developer-building",
      payload,
      toastMessage: "Application request updated successfully",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION, FIRE_SAFETY_COMMENT],
    }).unwrap();
  return [updateApplicationStatus, data];
};

export const useDeleteScheduleMutation = () => {
  const [deleteSchedule, data] = useDeleteMutation();
  const deleteScheduleData = async (id) =>
    await deleteSchedule({
      endpoint: `/schedule/${id}`,
      toastMessage: "Schedule deleted successfully.",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [deleteScheduleData, data];
};
